import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import isEmpty from 'lodash/isEmpty';
import { fetchPlacements } from 'core/actions/ocapi';

import InfoBarMarketingTile from './components/InfoBarMarketingTile';

import {
  selectInfoBarMarketingConfig,
  selectInfoBarMarketingIsLoading,
  selectInfoBarMarketingIsLoaded,
  selectInfoBarMarketingPlacementToDisplay,
  selectInfoBarMarketingResponseDate,
} from './selectors';

import './InfoBarMarketing.scss';

function InfoBarMarketing({ preventRender, className }) {
  const dispatch = useDispatch();

  const config = useSelector(selectInfoBarMarketingConfig);
  const isLoading = useSelector(selectInfoBarMarketingIsLoading);
  const isLoaded = useSelector(selectInfoBarMarketingIsLoaded);
  const offer = useSelector(selectInfoBarMarketingPlacementToDisplay);
  const responseDate = useSelector(selectInfoBarMarketingResponseDate);

  const { api: { params, options } } = config;

  useEffect(() => {
    if (!isLoading && !isLoaded) {
      dispatch(fetchPlacements(params, options));
    }
  });

  if (preventRender || isEmpty(offer)) {
    return null;
  }

  return (
    <InfoBarMarketingTile {...offer} responseDate={responseDate} className={className} />
  );
}

export default InfoBarMarketing;
